// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__wDL7I","contentHeader":"Layout_contentHeader__yETXL","contentHeaderTitle":"Layout_contentHeaderTitle__nQpDC"};